import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { FaShieldHalved } from "react-icons/fa6";
import { TbRefresh } from "react-icons/tb";
import { Link } from "react-router-dom";
import ImageSvg from "../ui/image-svg";

export const RastreamentoTempoRealSection = () => {
  return (
    <section className=" py-10 md:py-24 bg-white">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div className="order-1 md:order-2">
            <p className=" text-n-text-neutral mb-6">Rastreabilidade</p>
            <h2 className="mb-5 text-n-text-green text-3xl font-semibold md:mb-6 md:text-4xl lg:text-5xl">
              Acompanhe cada etapa do transporte do seu carro
            </h2>
            <p className="md:text-lg text-n-text-neutral mb-8">
              <strong>
                Mais tranquilidade com atualizações direto no seu celular
              </strong>
              .Nosso sistema de rastreamento permite{" "}
              <strong>
                acompanhar o transporte do seu veículo desde a coleta até a
                entrega
              </strong>
              , abrir chamados e muito mais. Tudo para garantir mais segurança,
              previsibilidade e transparência.
            </p>

            <div className="flex flex-row gap-2 items-center mb-8">
              <div className="flex flex-col bg-n-green-h-light  p-4 rounded-xl gap-4 flex-1 hover:bg-n-beige/20 duration-300">
                <TbRefresh className="h-8 w-8 text-n-primary" />
                <p className="text-n-text-green font-semibold text-md 2xl:text-lg">
                  Atualizações na palma da mão
                </p>
              </div>
              <div className="flex flex-col bg-n-green-h-light p-4 rounded-xl gap-4 flex-1 hover:bg-n-beige/20 duration-300">
                <FaShieldHalved className="h-8 w-8 text-n-primary" />
                <span className="text-n-text-green font-semibold text-md 2xl:text-lg">
                  Tranquilidade e segurança
                </span>
              </div>
            </div>

            <Link to="/fazer-cotacao">
              <Button>
                Agendar transporte
                <ArrowRight className="ml-2 h-6 w-6" />
              </Button>
            </Link>
          </div>
          <div className="order-1 md:order-2">
            <div className="flex items-center justify-center">
              <ImageSvg
                src="real-time.svg"
                alt="Rastreamento em tempo real"
                className="max-w-[50%] h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
